import React, { useState } from "react";

const Home = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can add the logic to handle the email submission
    console.log("Email submitted:", email);
    // Reset the email state
    setEmail("");
  };

  return (
    <div
      className="flex flex-col py-20 md:py-52 relative min-h-screen"
      style={{
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 1)), url(/images/hero.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex mb-10 md:mb-36 flex-col justify-center items-center px-4 md:py-12 w-full py-36">
        <div className="flex flex-col text-center md:text-left max-w-3xl mx-auto">
          <span className="text-3xl md:text-4xl font-bold text-white">
            Empower Your Education Journey with
            <span className="text-primary"> Study</span>cool
          </span>

          <span className="text-lg md:text-xl font-medium text-neutral-50 mt-4">
            Bridging educational inequalities and providing opportunities for
            growth.
          </span>
        </div>
        <div className="mt-4 md:mt-7 text-sm md:text-base text-white text-center md:text-left max-w-3xl mx-auto">
          Discover Studycool, the platform revolutionizing your university
          experience by centralizing courses, events, and student support.
          Simplify your academic life today!
        </div>
        <div className="flex justify-center mt-4 w-full max-w-md mx-auto">
          <form onSubmit={handleSubmit} className="w-full flex">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-4 py-2 md:px-6 md:py-3 rounded-l-[50px] text-black"
            />
            <button
              type="submit"
              className="px-5 md:px-7 py-3 md:py-4 text-lg md:text-2xl text-white bg-primary rounded-r-[50px] hover:bg-white hover:text-primary transition-colors duration-300"
            >
              Discover
            </button>
          </form>
        </div>
      </div>
      <img
        loading="lazy"
        src="/images/wave.svg"
        className="w-full absolute bottom-[-3px]"
        alt="waves"
      />
    </div>
  );
};

export default Home;
